'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-behavior',
        name: 'ai-behavior',
        meta: {
            title: 'AI behavior & tone',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-behavior/index'),
    },
];
